// # interfaces
import { iAuthService } from '@/services/auth';

export default abstract class Policy {
    /**
     * The auth service.
     */
    protected authService: iAuthService;

    constructor(authService: iAuthService) {
        this.authService = authService;
    }
}
